<template>
  <div class="text-left"
    :class="!large ? 'cursor-pointer' : ''"
    :id="large ? hash : ''"
    @click="goToDashboard">
    <div class="flex items-center text-gray-600 tracking-widest text-xl mb-2 uppercase px-6">
      <img :src="urlProfilePhoto" class="w-10 rounded-full">
      <h1 class="ml-6 text-orange-academy-300">
        <slot name="header"></slot>
      </h1>
    </div>
    <div v-show="large" class="ml-16 px-6">
      <p>
        <slot></slot>
      </p>
      <div class="flex flex-col md:flex-row mt-2 items-center justify-between pr-24">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    urlProfilePhoto: {
      type: String,
      default: 'https://baroon.fra1.cdn.digitaloceanspaces.com/dev/academy/users/Placeholder_teacher.jpg',
    },
    large: {
      type: Boolean,
      default: true,
    },
    hash: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    ...mapActions({
      toggleNotifications: 'toggleNotifications',
    }),
    goToDashboard() {
      if (!this.large) {
        this.toggleNotifications();
        this.$router.push(`/${this.user.user_type.toLowerCase()}-dashboard#${this.hash}`).catch(() => {});
      }
    },
  },
};
</script>
